import { timeLessGetInfo } from "../apis"
import { getTimeList } from "../common"
import userInfo from "./userinfo"

function Info() {
    this.awardStatus = 0
    this.lotteryAwardStatus = 0
    this.lotteryAward = 0
    this.times = 0
    this.cardInfo = [],
    this.isAddress = false
    this.taskInfo = []
    this.task3Times = 0
    this.receiveTimes = 0
    this.sendTimes = 0
    this.daySendTimes = 0
    this.addr = {
        name: "",
        phone: "",
        address: "",
    }
    this.hasInfo = false
    this.isOpen = false
    this.isEnd = false
    this.hasTime = false
}
Info.prototype.setDatas = function (data) {
    this.awardStatus = data.awardStatus
    this.lotteryAwardStatus = data.lotteryAwardStatus
    this.lotteryAward = data.lotteryAward
    this.times = data.times
    this.cardInfo = data.cardInfo
    this.isAddress = data.isAddress
    this.taskInfo = data.taskInfo
    this.task3Times = data.task3Times
    this.receiveTimes = data.receiveTimes
    this.sendTimes = data.sendTimes
    this.daySendTimes = data.daySendTimes
    this.addr = data.addr
    this.hasInfo = true
}

Info.prototype.getTime = function () {
    if (this.hasTime) {
        return
    }
    getTimeList().then((res) => {
        if (res.code == 0) {
            this.isOpen = res.drawTime.isOpen
            this.isEnd = res.drawTime.isEnd
            this.hasTime = true
        }
    }).catch((err) => {
        console.log(err)
    })
}

Info.prototype.getInfo = async function (force = false) {
    if (this.hasInfo && !force) {
        return true
    }

    if (!userInfo.isLogin) {
        return false
    }

    let res = await timeLessGetInfo()
    if (res.code !== 0) {
        throw res.message
    }
    this.setDatas(res)

    return true
}

export default new Info()